/**
 * Partner: 0 when the partner holds the policy eligibility
 * Self: 1 when the policy holder holds the eligibility
 */

export const WhoIsEligible = Object.freeze({
  PARTNER: 0,
  SELF: 1,
});

export const WhoIsEligibleString = Object.freeze({
  PARTNER: 'partner',
  SELF: 'self',
});
